

// import React, { useEffect, useState, useCallback, memo } from 'react';
// import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';
// import axios from 'axios';

// const MapWithMarkers = memo(({ coordinates, orders }) => {
//   const [selectedMarker, setSelectedMarker] = useState(null);

//   const mapContainerStyle = {
//     width: '800px',
//     height: '400px'
//   };

//   const center = {
//     lat: 17.4455687,
//     lng: 78.3875588
//   };

//   const handleMarkerClick = useCallback((order) => {
//     setSelectedMarker(prev => prev?.eventorder_generated_id === order.eventorder_generated_id ? null : order);
//   }, []);

//   const handleMarkerMouseOver = useCallback((order) => {
//     setSelectedMarker(order);
//   }, []);

//   const handleMarkerMouseOut = useCallback(() => {
//     setSelectedMarker(null);
//   }, []);

//   return (
//     <div className="relative">
//       <GoogleMap
//         mapContainerStyle={mapContainerStyle}
//         center={center}
//         zoom={15}
//       >
//         {coordinates.map((coord, index) => {
//           const order = orders[index];
//           const { eventorder_generated_id } = order;
          
//           const markerPosition = {
//             lat: parseFloat(coord.latitude),
//             lng: parseFloat(coord.longitude),
//           };

//           return (
//             <MarkerF
//               key={eventorder_generated_id}
//               position={markerPosition}
//               onClick={() => handleMarkerClick(order)}
//               onMouseOver={() => handleMarkerMouseOver(order)}
//               onMouseOut={handleMarkerMouseOut}
//             />
//           );
//         })}
//       </GoogleMap>
      
//       {/* Enhanced Custom Info Display */}
//       {selectedMarker && (
//         <div className="absolute top-4 left-4 bg-white rounded-lg shadow-lg overflow-hidden w-64 border border-gray-100">
//           {/* Header Section */}
//           <div className="bg-gray-50 px-4 py-2 border-b border-gray-100 flex justify-between items-center">
//             <div className="flex items-center space-x-2">
//               <div className="w-2 h-2 bg-green-500 rounded-full"></div>
//               <h3 className="font-semibold text-gray-700 text-sm">
//                 Order Details
//               </h3>
//             </div>
//             <button 
//               onClick={() => setSelectedMarker(null)}
//               className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-xl font-medium w-6 h-6 flex items-center justify-center leading-none"
//             >
//               ×
//             </button>
//           </div>

//           {/* Content Section */}
//           <div className="px-4 py-3 space-y-2">
//             <div className="flex items-center space-x-2">
//               <span className="text-xs font-medium text-gray-500">ORDER ID</span>
//               <span className="text-sm text-gray-700">{selectedMarker.eventorder_generated_id}</span>
//             </div>
//             <div className="space-y-1.5">
//               <div className="flex items-start">
//                 <span className="text-gray-500 text-sm w-16">Name</span>
//                 <span className="text-sm text-gray-700 font-medium ml-2">
//                   {selectedMarker.customer_address?.ship_to_name}
//                 </span>
//               </div>
//               <div className="flex items-start">
//                 <span className="text-gray-500 text-sm w-16">Phone</span>
//                 <span className="text-sm text-gray-700 font-medium ml-2">
//                   {selectedMarker.customer_address?.ship_to_phone_number}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// });

// const Undeliveredorders = () => {
//   const [orders, setOrders] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [coordinates, setCoordinates] = useState([]);

//   useEffect(() => {
//     const fetchOrders = async () => {
//       try {
//         const token = localStorage.getItem('token');
//         const response = await axios.get(`${process.env.REACT_APP_ADMIN_API_URL}/api/orders`, {
//           headers: {
//             token: token
//           }
//         });
//         setOrders(response.data);

//         const locations = response.data
//           .map((order) => order.customer_address?.location)
//           .filter(Boolean);

//         const coords = locations
//           .map(locationUrl => {
//             const match = locationUrl.match(/q=([-0-9.]+),([-0-9.]+)/);
//             return match ? { latitude: match[1], longitude: match[2] } : null;
//           })
//           .filter(coord => coord !== null);

//         setCoordinates(coords);
//       } catch (err) {
//         setError('Failed to fetch orders');
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchOrders();
//   }, []);

//   if (loading) return (
//     <div className="flex justify-center items-center min-h-screen">
//       Loading...
//     </div>
//   );

//   if (error) return (
//     <div className="flex justify-center items-center min-h-screen text-red-500">
//       {error}
//     </div>
//   );

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <h1 className="text-2xl font-bold mb-6 text-center text-orange-500">Undelivered Orders</h1>
      
//       {/* Map Section */}
//       <div className="flex justify-center mb-8">
//         <LoadScript googleMapsApiKey="AIzaSyCA8Z6wYNtBvsYbbt2HDnI706WU8qUaVCU">
//           {coordinates.length > 0 && (
//             <MapWithMarkers coordinates={coordinates} orders={orders} />
//           )}
//         </LoadScript>
//       </div>

//       <div className="text-center mb-8">
//             <p className="text-lg font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-lg py-2 px-4 inline-block shadow-sm">
//                 Total Undelivered Orders: 
//                 <span className="text-orange-500 font-bold ml-1">{orders.length}</span>
//             </p>
//             </div>

//       <div className="max-w-3xl mx-auto">
//         <ul className="space-y-4">
//           {orders.map((order) => (
//             <li 
//               key={order.eventorder_generated_id}
//               className="border rounded-lg p-4 shadow-sm"
//             >
//               <p className="font-semibold">Order ID: {order.order_generated_id}</p>
//               <p className="truncate">
//                 Customer Address: {order.customer_address.line1} {order.customer_address.line2} {order.customer_address.pincode}
//               </p>
//             </li>
//           ))}
//         </ul>
//       </div>
//     </div>
//   );
// };

// export default Undeliveredorders;




import React, { useEffect, useState, useCallback, memo } from 'react';
import { GoogleMap, LoadScript, MarkerF } from '@react-google-maps/api';
import axios from 'axios';

const MapWithMarkers = memo(({ coordinates, orders }) => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const [map, setMap] = useState(null);

  // Make map container style responsive
  const mapContainerStyle = {
    width: '100%',
    height: '400px',
    maxWidth: '800px',
    position: 'relative'
  };

  const center = {
    lat: 17.4455687,
    lng: 78.3875588
  };

  const handleMarkerClick = useCallback((order) => {
    setSelectedMarker(prev => prev?.eventorder_generated_id === order.eventorder_generated_id ? null : order);
  }, []);

  const handleMarkerMouseOver = useCallback((order) => {
    setSelectedMarker(order);
  }, []);

  const handleMarkerMouseOut = useCallback(() => {
    setSelectedMarker(null);
  }, []);

  // Custom zoom control styles
  const zoomControlStyle = {
    position: 'absolute',
    right: '10px',
    bottom: '40px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    zIndex: 1
  };

  const zoomButtonStyle = {
    width: '32px',
    height: '32px',
    backgroundColor: 'white',
    border: '1px solid #ccc',
    borderRadius: '4px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '18px',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    transition: 'background-color 0.2s',
    ':hover': {
      backgroundColor: '#f0f0f0'
    }
  };

  const handleZoomIn = () => {
    if (map) {
      map.setZoom(map.getZoom() + 1);
    }
  };

  const handleZoomOut = () => {
    if (map) {
      map.setZoom(map.getZoom() - 1);
    }
  };

  return (
    <div className="relative w-full max-w-[800px] mx-auto">
      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={center}
        zoom={15}
        onLoad={setMap}
        options={{
          zoomControl: false,
          streetViewControl: true,
          mapTypeControl: true,
          fullscreenControl: true
        }}
      >
        {coordinates.map((coord, index) => {
          const order = orders[index];
          const { eventorder_generated_id } = order;
          
          const markerPosition = {
            lat: parseFloat(coord.latitude),
            lng: parseFloat(coord.longitude),
          };

          return (
            <MarkerF
              key={eventorder_generated_id}
              position={markerPosition}
              onClick={() => handleMarkerClick(order)}
              onMouseOver={() => handleMarkerMouseOver(order)}
              onMouseOut={handleMarkerMouseOut}
            />
          );
        })}
      </GoogleMap>

      {/* Custom Zoom Controls */}
      <div 
        style={zoomControlStyle}
        className="sm:right-4 sm:bottom-10 right-2 bottom-8"
      >
        <button
          onClick={handleZoomIn}
          style={zoomButtonStyle}
          className="hover:bg-gray-100"
          aria-label="Zoom in"
        >
          +
        </button>
        <button
          onClick={handleZoomOut}
          style={zoomButtonStyle}
          className="hover:bg-gray-100"
          aria-label="Zoom out"
        >
          −
        </button>
      </div>
      
      {/* Info Window */}
      {selectedMarker && (
        <div className="absolute top-4 left-4 bg-white rounded-lg shadow-lg overflow-hidden w-64 border border-gray-100 sm:w-72">
          <div className="bg-gray-50 px-4 py-2 border-b border-gray-100 flex justify-between items-center">
            <div className="flex items-center space-x-2">
              <div className="w-2 h-2 bg-green-500 rounded-full"></div>
              <h3 className="font-semibold text-gray-700 text-sm">
                Order Details
              </h3>
            </div>
            <button 
              onClick={() => setSelectedMarker(null)}
              className="text-gray-400 hover:text-red-500 transition-colors duration-200 text-xl font-medium w-6 h-6 flex items-center justify-center leading-none"
            >
              ×
            </button>
          </div>

          <div className="px-4 py-3 space-y-2">
            <div className="flex items-center space-x-2">
              <span className="text-xs font-medium text-gray-500">ORDER ID</span>
              <span className="text-sm text-gray-700">{selectedMarker.order_generated_id}</span>
            </div>
            <div className="space-y-1.5">
              <div className="flex items-start">
                <span className="text-gray-500 text-sm w-16">Name</span>
                <span className="text-sm text-gray-700 font-medium ml-2">
                  {selectedMarker.customer_address?.ship_to_name}
                </span>
              </div>
              <div className="flex items-start">
                <span className="text-gray-500 text-sm w-16">Phone</span>
                <span className="text-sm text-gray-700 font-medium ml-2">
                  {selectedMarker.customer_address?.ship_to_phone_number}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
});

const Undeliveredorders = () => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [coordinates, setCoordinates] = useState([]);

  useEffect(() => {
    const fetchOrders = async () => {
      try {
        const token = localStorage.getItem('token');
        const response = await axios.get(`${process.env.REACT_APP_ADMIN_API_URL}/api/orders`, {
          headers: {
            token: token
          }
        });
        setOrders(response.data);

        const locations = response.data
          .map((order) => order.customer_address?.location)
          .filter(Boolean);

        const coords = locations
          .map(locationUrl => {
            const match = locationUrl.match(/q=([-0-9.]+),([-0-9.]+)/);
            return match ? { latitude: match[1], longitude: match[2] } : null;
          })
          .filter(coord => coord !== null);

        setCoordinates(coords);
      } catch (err) {
        setError('Failed to fetch orders');
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, []);

  if (loading) return (
    <div className="flex justify-center items-center min-h-screen">
      Loading...
    </div>
  );

  if (error) return (
    <div className="flex justify-center items-center min-h-screen text-red-500">
      {error}
    </div>
  );

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold mb-6 text-center text-orange-500">Undelivered Orders</h1>
      
      {/* Map Section */}
      <div className="flex justify-center mb-8">
        <LoadScript googleMapsApiKey="AIzaSyCA8Z6wYNtBvsYbbt2HDnI706WU8qUaVCU">
          {coordinates.length > 0 && (
            <MapWithMarkers coordinates={coordinates} orders={orders} />
          )}
        </LoadScript>
      </div>

      <div className="text-center mb-8">
        <p className="text-lg font-medium text-gray-700 bg-gray-50 border border-gray-200 rounded-lg py-2 px-4 inline-block shadow-sm">
          Total Undelivered Orders: 
          <span className="text-orange-500 font-bold ml-1">{orders.length}</span>
        </p>
      </div>

      <div className="max-w-3xl mx-auto">
        <ul className="space-y-4">
          {orders.map((order) => (
            <li 
              key={order.eventorder_generated_id}
              className="border rounded-lg p-4 shadow-sm"
            >
              <p className="font-semibold">Order ID: {order.order_generated_id}</p>
              <p className="truncate">
                Customer Address: {order.customer_address.line1} {order.customer_address.line2} {order.customer_address.pincode}
              </p>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Undeliveredorders;